import styled from '@emotion/styled';
import { Button } from 'components';
import SimplePageLayout from 'components/SimplePageLayout';
import colors from 'lib/colors';
import { useTranslation } from 'react-i18next';
import useLogout from 'utils/useLogout';

const AccessDenied = () => {
  const { loading: logingOut, logout } = useLogout();

  const { t } = useTranslation();

  return (
    <SimplePageLayout>
      <Title>
        {t(`accessDenied.title`, 'Nemáte povolený přístup do Clashingu')}
      </Title>
      <Subtitle>
        {t(
          'accessDenied.subTitle',
          'Aktuálně nesplňujete podmínky pro přihlášení se do hry Clashing.Vyčkejte prosím na pozvánku do školení od vašeho vzdělávacího managera.',
        )}
      </Subtitle>
      <Button
        extraWide
        variant="warning"
        onClick={logout}
        disabled={logingOut}
        labelT={{ key: 'accessDenied.button', defaultValue: 'Odhlásit se' }}
      />
    </SimplePageLayout>
  );
};

export default AccessDenied;

const Title = styled('h2')({
  color: colors.white,
  fontSize: 20,
  marginBottom: '0.375rem',
});

const Subtitle = styled('p')({
  textAlign: 'center',
  color: colors.lobbyText,
  fontSize: '14px',
  lineHeight: 1.5,
  letterSpacing: 0,
  margin: 0,
  maxWidth: 440,
  marginBottom: '1.25rem',
});
